<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo />

    <div class="p-8 bg-white mt-6 rounded shadow-lg border" @keyup.enter="submit">

      <div class="text-2xl font-light text-gray-700">
        Please type in the 6-digit code
      </div>

      <div class="mt-6 leading-normal text-base">
        Please verify your login by typing in the 6-digit code that was sent to your phone below.
      </div>

      <div class="mt-8">
        <input type="text"
          v-model="code"
          ref='code'
          class="input-standard"
          :disabled="loading" />

        <div v-if="codeError !== null" class="text-red-500 mt-2 mb-4 text-sm">{{ codeError }}</div>
      </div>

      <div class="mt-2 text-sm flex items-center">
        <input type="checkbox" class="mr-2" id="input-save-for-30-days" v-model="saveFor30Days" />
        <label for="input-save-for-30-days" class="text-gray-800">Don't ask me again for next 30 days</label>
      </div>

      <div class="mt-8">
        <button
          v-on:click="submit"
          class="text-white py-4 w-full bg-blue-500 font-semibold hover:bg-blue-500">
          <template v-if="loading"><img src="/static/img/ajax-loader.gif" class="inline" /></template>
          <template v-else>Submit</template>
        </button>
      </div>

      <div class="mt-4 text-center">
        <a href="#" @click.prevent="sendAgain" class="text-sm text-gray-600 hover:underline">Didn't get the code? Send again</a>
      </div>
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>
  import { EventBus }   from '@/shared/event-bus'
  import PublicFooter   from "@/shared/components/public/Footer"
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo'

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    data() {
      return {
        loading      : false,
        code         : null,
        codeError    : null,
        saveFor30Days: true
      }
    },

    mounted() {
      this.$refs.code.focus()
      document.body.className = 'bg-gray-100'
    },

    methods : {

      sendAgain() {
        this.loading = true
        this.apiPost({
          userId: this.$route.params.userId
        }, 'auth/send-mfa-verification-code', (res) => {
          this.loading = false
          EventBus.$emit('notification-event', {
            'type'   : 'success', 
            'message': 'MFA code sent.'
          })
        })
      },

      submit() {
        let valid      = true
        this.codeError = null

        if(this.code == null || isNaN(this.code) || this.code.length !== 6) {
          this.codeError = "Please type in a valid 6-digit code."
          valid = false
        }

        if(valid) {
          this.loading = true
          this.apiPost({
            code         : this.code,
            saveFor30Days: this.saveFor30Days ? 1 : 0,
            userId       : this.$route.params.userId
          }, 'auth/verify-mfa-code', (res) => {

            this.loading = false

            if(res != null && res.error != null) {
              this.codeError = res.error
            }

            else {

              localStorage.setItem("bp-broker-jwt", res.token)
              this.$store.commit('setIsLoggedIn', true)

              // check if we have redirectUrl
              if(this.$store.state.redirectUrl) {
                this.$router.push(this.$store.state.redirectUrl)
                this.$store.commit('setRedirectUrl', null)
              }

              else {

                this.getUser({
                  force : true
                }, (user) => {

                  if(user != null) {
                    this.$router.push({
                      name : user.broker.should_show_landing == 1 ? 'broker-home' : 'client-list'
                    });
                  }

                })
              }
            }
          })
        }
      },
    },
  }
</script>